import { DEFAULTS } from "./constants";
import { GIPHY_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers-loadable";
const pluginGiphy = (config) => {
  return {
    config: { ...DEFAULTS.configViewer, ...config },
    type: GIPHY_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginGiphy
};
//# sourceMappingURL=viewer-loadable.js.map
